import { render, staticRenderFns } from "./AdvisorCoreStart.vue?vue&type=template&id=4362218e&scoped=true&"
import script from "./AdvisorCoreStart.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4362218e",
  null
  
)

export default component.exports